export enum BankFormCopy {
  BankName = 'Bank Name',
  BankRoutingDomestic = 'Bank ABA Routing / SWIFT / BIC',
  BankRoutingInternational = 'Bank SWIFT / BIC',
  City = 'City',
  Country = 'Country',
  Destination = 'Destination',
  PostalCode = 'Postal Code',
  StateProv = 'State / Province',
  TitleBeneficiaryBank = 'Beneficiary Bank',
  TitleHelperText = "Adjust beneficiary to 'Account holder' for international bank.",
  UseIntermediaryAccount = 'Use Intermediary Account',
  ValueDomestic = 'Domestic',
  ValueInternational = 'International'
}
